import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFileCloud: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFileCloud"><Path d="M4.5 13V2.5H13L19.5 9V21.5H12.5" stroke="currentColor" strokeLinecap="square"/><Path d="M13 3V9H19" stroke="currentColor" strokeLinecap="round"/><Path d="M5.25 16C6.32791 16 7.25898 16.6204 7.70996 17.5225C7.80485 17.5086 7.90156 17.5 8 17.5C9.10457 17.5 10 18.3954 10 19.5C10 20.6046 9.10457 21.5 8 21.5H5.25C3.73122 21.5 2.5 20.2688 2.5 18.75C2.5 17.2312 3.73122 16 5.25 16Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconFileCloud;
